/**
 * UnauthorizedPage (403)
 * หน้าปฏิเสธการเข้าถึง
 */

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { ShieldX, ArrowLeft, Home } from 'lucide-react'

export function UnauthorizedPage() {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-6 text-center">
      {/* Icon */}
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-100 dark:bg-red-950/30">
        <ShieldX className="h-10 w-10 text-red-500" />
      </div>

      {/* Message */}
      <div>
        <h1 className="text-foreground text-2xl font-bold">{t('auth.unauthorized')}</h1>
        <p className="text-muted-foreground mt-2 text-sm">{t('auth.unauthorizedMessage')}</p>
      </div>

      {/* Actions */}
      <div className="flex gap-3">
        <Button variant="outline" asChild>
          <Link to={-1 as unknown as string} id="go-back-btn">
            <ArrowLeft className="mr-2 h-4 w-4" />
            {t('auth.goBack')}
          </Link>
        </Button>
        <Button asChild>
          <Link to="/" id="go-dashboard-btn">
            <Home className="mr-2 h-4 w-4" />
            {t('auth.goToDashboard')}
          </Link>
        </Button>
      </div>
    </div>
  )
}
